/**
 * Governance mode for driver-initiated par edits (per scope: customer / vehicle).
 *   - off    — reject driver par writes for the scope
 *   - review — driver edits become pending Par_Proposals an admin approves before they apply
 *   - trust  — driver edits upsert the authoritative par directly
 */
export const PAR_EDIT_MODE_OPTIONS = [
    { value: "off", title: "Off" },
    { value: "review", title: "Review" },
    { value: "trust", title: "Trust" },
] as const;

type ParEditMode = (typeof PAR_EDIT_MODE_OPTIONS)[number]["value"];

export default ParEditMode;
